import { Link } from 'react-router-dom';
import { Home, Mail } from 'lucide-react';

export default function PageHeader() {
  return (
    <header className="messages-header">
      <Link to="/" state={{ forceInvitation: true }}><Mail size={17} /> CONVITE</Link>
      <div className="messages-brand"><strong>VALENTINA</strong><span>quinze anos</span></div>
      <Link to="/" state={{ skipInvitation: true }}><Home size={17} /> INÍCIO</Link>
    </header>
  );
}
